/**
 * STYLE GUIDE
 *
 * For consistency, please use Kebab Case for all multi-word variables.
 * For example, the site fires a `route-changed` event as the user moves
 * between pages:
 *
 * ```
 *   dataLayerPush({ event: 'route-changed' });
 * ```
 *
 * If the variable name is multiple words and thus requires hyphens, please
 * remember to pass those as strings. JavaScript will yell otherwise.
 *
 * ```
 *   dataLayerPush({ 'new-variable': 'value' });
 * ```
 *
 * See: https://developers.google.com/tag-manager/devguide#variable-names-should-be-kept-consistent-across-pages
 */

/**
 * Push an object to Google Tag Manager's data layer, if one is found.
 * @param {Object} obj Object to push to the data layer.
 * @see https://developers.google.com/tag-manager/devguide#events
 */
export function dataLayerPush(obj) {
    // Check that we're in production and that we have the Tag Manager's data layer.
    if (typeof window === 'undefined' || !window.dataLayer || !obj) return;

    window.dataLayer.push(obj);
}

/**
 * Push an event to Google Tag Manager's data layer, if one is found.
 * @param {Object} event Event object to push to the data layer.
 * @see https://developers.google.com/tag-manager/devguide
 */
export function trackCustomEvent(event) {
    return dataLayerPush(event);
}
